<ion-item class="item-list-box" [ngClass]="{'AQA-setItem': isSet, 'AQA-aLaCarteItem': !isSet}" (click)="addClicked()">

  <div *ngIf="isSoldout" class="sold-out-box AQA-soldOut">
    <p>{{"pages.item-grid.soldout" | translate}}</p>
  </div>

  <ion-thumbnail slot="end" *ngIf="img">
    <img [lazyLoad]="img" >
    <!-- <img src="{{img}}"> -->
  </ion-thumbnail>

  <div class="qty-box" slot="end">
    <!-- Action bar for Set -->
    <ng-container *ngIf="isSet && _quantity === 0">
      <div class="pre-quantity-box" >
        <ion-button fill="clear">
          <ion-icon color="dark" name="ios-arrow-forward"></ion-icon>
        </ion-button>
      </div>
    </ng-container>

    <!-- Action bar for A-la-carte with modifier-->
    <div class="pre-quantity-box"
         *ngIf=" !isSet && (isRequiredModifier ||(!orderManager?.store?.menu?.quickSingleItem && isModifiable)) "
         slot="end">
      <ion-button fill="clear">
        <ion-icon color="dark" name="ios-arrow-forward"></ion-icon>
      </ion-button>
    </div>
    <div class="pre-quantity-box" *ngIf=" !isSet && !isRequiredModifier && (orderManager?.store?.menu?.quickSingleItem || !isModifiable) && _quantity === 0"
    >
      <ion-button fill="clear" class="aig-add-circle AQA-add-button">
        <ion-icon name="add-circle-outline" color="success"></ion-icon>
      </ion-button>
    </div>
    <div class="quantity-box" *ngIf=" !isSet && !isRequiredModifier && (orderManager?.store?.menu?.quickSingleItem || !isModifiable) && _quantity > 0"
    >
      <ion-button fill="clear" class="aig-add-circle AQA-add-button">
        <ion-icon name="add-circle-outline" color="success"></ion-icon>
      </ion-button>
      <ion-button fill="clear" (click)="removeClicked();$event.stopPropagation();" class="aig-minus-circle AQA-minus-button">
        <ion-icon name="remove-circle-outline" color="medium"></ion-icon>
      </ion-button>
    </div>
  </div>

  <div>
    <div class="name-box">
      <p class="name-text line-clamp">
        <ng-container *ngIf="_quantity > 0">
          <span class="qty-text AQA-item-qty">{{_quantity}}x </span>
        </ng-container>
        {{name}}
      </p>
      <!--<div *ngIf="item.tags.length > 0" class="tag-image-box list">
        <ng-container *ngFor="let tagsImg of item.tags">
          <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}" [ngClass]="{'single' : item.tags.length == 1}">
        </ng-container>
      </div>-->
    </div>
    <p class="desc-text line-clamp-3" *ngIf="_item.desc">{{ _item.desc }}</p>
    <p class="price-text itemPrice-text" *ngIf="!orderManager?.store?.menu?.settings.hideZeroItemPrice || _item.price > 0">{{orderManager?.store?.currencySign}}{{ _item.price | number : '1.0-2'}}</p>
  </div>



</ion-item>
